import React from 'react';
import MyProfilePage from './MyProfilePage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Backend from '../../Layouts/Backend';
import Loading from '../../Helpers/Loading';
import { configureActions } from '../../../actions/configure.action';
import { generalActions } from '../../../actions/general.action';
import helper from '../../../utils/helper';
import { accountActions } from '../../../actions/account.action';

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProfile: {},
      loading: false,
      isSubmitting: false,
      departments: [],
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.general.currentProfile !== prevState.currentProfile) {
      state.currentProfile = nextProps.general.currentProfile;
    }
    if (nextProps.configure.departments !== prevState.departments) {
      state.departments = nextProps.configure.departments;
    }
    if (nextProps.configure.roles !== prevState.roles) {
      state.roles = nextProps.configure.roles;
    }
    if (nextProps.configure.groups !== prevState.groups) {
      state.groups = nextProps.configure.groups;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.general.errors,
      nextProps.account.error,
    ]);
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    //await this.props.configureActions.getDepartments()
    await this.props.generalActions.getCurrentProfile();
  }
  onBack = () => {
    this.props.history.goBack();
  };
  onSubmit = async (values, isChangePwd) => {
    this.props.generalActions.clearError();
    this.setState(
      { isSubmitting: true },
      async () =>
        await this.props.generalActions
          .updateCurrentProfile(values)
          .then(async () => {
            if (isChangePwd) {
              await this.props.accountActions.changePassword({
                currentPassword: values.currentPassword,
                newPassword: values.password,
              });
            }
          })
          .finally(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    const { loading, currentProfile, departments } = this.state;
    if (loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    if (Object.keys(currentProfile).length) {
      if (departments.length) {
        currentProfile.departmentName = departments.filter(
          (dept) => dept.id === currentProfile.departmentId,
        )[0].name;
      }
      if (currentProfile.workDaysOfWeek) {
        if (!Array.isArray(currentProfile.workDaysOfWeek)) {
          if (currentProfile.workDaysOfWeek.trim()) {
            currentProfile.workDaysOfWeek = currentProfile.workDaysOfWeek
              .split(',')
              .map((w) => w.trim());
          } else {
            currentProfile.workDaysOfWeek = [];
          }
        }
      } else {
        currentProfile.workDaysOfWeek = [];
      }
      if (typeof currentProfile.startWork === 'string') {
        const t = currentProfile.startWork.split(':');
        let hour = t[0];
        if (t[t.length - 1].includes('PM') && hour !== '12') {
          hour = parseInt(hour) + 12;
        }
        currentProfile.startWork = new Date().setHours(hour, t[1]);
      }
      if (typeof currentProfile.endWork === 'string') {
        const t = currentProfile.endWork.split(':');
        let hour = t[0];
        if (t[t.length - 1].includes('PM') && hour !== '12') {
          hour = parseInt(hour) + 12;
        }
        currentProfile.endWork = new Date().setHours(hour, t[1]);
      }
    }
    return (
      <MyProfilePage
        {...this.state}
        currentProfile={currentProfile}
        onBack={this.onBack}
        onSubmit={this.onSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    general: state.general,
    account: state.account,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
    accountActions: bindActionCreators(
      Object.assign({}, accountActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
